import { FormControl, FormControlProps, FormHelperText, InputLabel, Select, SelectChangeEvent } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface IFormControlProps extends FormControlProps {
  setValueSelected: (value: any) => void;
  label: string;
  helperText: string | undefined;
  defaultValueSelected?: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
    },
  },
};

const WizardSelect: React.FC<IFormControlProps> = ({
  label,
  children,
  error,
  helperText,
  defaultValueSelected,
  ...rest
}) => {
  const [selected, setSelected] = useState('');

  const handleChange = (event: SelectChangeEvent) => {
    setSelected(event.target.value);
    rest.setValueSelected(event.target.value);
  };

  useEffect(() => {
    setSelected(defaultValueSelected);
  }, [defaultValueSelected]);

  return (
    <FormControl sx={{ width: '300px', marginBottom: '20px' }} error={error}>
      <InputLabel id="label-select" size="small">
        {label}
      </InputLabel>

      <Select
        onChange={handleChange}
        value={selected}
        sx={{ width: '300px' }}
        labelId="label-select"
        id="select"
        label={label}
        size="small"
        MenuProps={MenuProps}
      >
        {children}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default WizardSelect;
